var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.display
    ? _c(
        "div",
        {
          staticClass: "modal-backdrop",
          attrs: { tabindex: "0" },
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.cancel()
            }
          }
        },
        [
          _c("div", { staticClass: "cart-modal" }, [
            _c("div", { staticClass: "cart-modal__inner" }, [
              _c("div", { staticClass: "cart-modal__header" }, [
                _c("h2", { staticClass: "cart-modal__heading" }, [
                  _vm._v("\n          Muokataan tuotetta\n        ")
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "cart-modal__close",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.cancel()
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "screen-reader-text" }, [
                      _vm._v("Peruuta")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cart-modal__body" }, [
                _c(
                  "div",
                  { staticClass: "cart-modal__image-column" },
                  [
                    _c("span", { staticClass: "label label--small" }, [
                      _vm._v("Tuotekuva")
                    ]),
                    _vm._v(" "),
                    _c(
                      "file-upload",
                      {
                        ref: "imageupload",
                        attrs: {
                          "post-action": "/wp-json/wp/v2/media",
                          extensions: "jpg,jpeg,gif,png",
                          headers: { "X-WP-Nonce": _vm.nonce },
                          size: 1024 * 1024,
                          drop: false
                        },
                        on: {
                          "input-file": _vm.inputFile,
                          "input-filter": _vm.inputFilter
                        },
                        model: {
                          value: _vm.files,
                          callback: function($$v) {
                            _vm.files = $$v
                          },
                          expression: "files"
                        }
                      },
                      [
                        _vm.hasImage && (_vm.product.image || _vm.customImage)
                          ? _c("img", {
                              directives: [
                                {
                                  name: "lazy",
                                  rawName: "v-lazy",
                                  value:
                                    _vm.customImage ||
                                    _vm.product.image.productTeaser,
                                  expression:
                                    "customImage || product.image.productTeaser"
                                }
                              ],
                              staticClass: "cart-modal__image",
                              class: {
                                "cart-modal__image--cropped": _vm.customImage
                              },
                              attrs: {
                                srcset:
                                  _vm.customImage ||
                                  _vm.product.image.productTeaser +
                                    " 1x, " +
                                    _vm.product.image.productTeaserX2 +
                                    " 2x",
                                alt: ""
                              }
                            })
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "cart-modal__image cart-modal__image--placeholder"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "cart-modal__image--placeholder__text"
                                  },
                                  [_vm._v("Ei kuvaa")]
                                )
                              ]
                            )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "cart-modal__image-actions",
                        class: {
                          "cart-modal__image-actions--no-image": _vm.hasImage
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "cart-modal__image-action btn btn--secondary btn--secondary-small",
                            class: { "btn--disabled": !_vm.hasImage },
                            attrs: { disabled: !_vm.hasImage },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.removeImage()
                              }
                            }
                          },
                          [_vm._v("\n              Poista\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass:
                              "cart-modal__image-action btn btn--secondary btn--secondary-small",
                            attrs: { for: "file" }
                          },
                          [_vm._v(_vm._s(_vm.hasImage ? "Vaihda" : "Lisää"))]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "cart-modal__content-column" }, [
                  _c(
                    "label",
                    {
                      staticClass: "label label--small",
                      attrs: { for: "product_name" }
                    },
                    [_vm._v("Tuotenimi")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.product.custom_name,
                        expression: "product.custom_name"
                      }
                    ],
                    attrs: { id: "product_name", type: "text" },
                    domProps: { value: _vm.product.custom_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.product,
                          "custom_name",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "label label--small",
                      attrs: { for: "product_description" }
                    },
                    [_vm._v("Tuotekuvaus")]
                  ),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.product.description,
                        expression: "product.description"
                      }
                    ],
                    staticClass: "textarea-med",
                    attrs: { id: "product_description" },
                    domProps: { value: _vm.product.description },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.product,
                          "description",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "cart-modal__position-id" }, [
                    _c(
                      "label",
                      {
                        staticClass: "label label--small",
                        attrs: { for: "product_position_id" }
                      },
                      [_vm._v("Positiotunnus")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.product.position_id,
                          expression: "product.position_id"
                        }
                      ],
                      attrs: { id: "product_position_id", type: "text" },
                      domProps: { value: _vm.product.position_id },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.product,
                            "position_id",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "grid-wrap" }, [
                    _c("div", { staticClass: "grid-col bp1-col-one-third" }, [
                      _c(
                        "label",
                        {
                          staticClass: "label label--small",
                          attrs: { for: "product_costprice" }
                        },
                        [_vm._v("Kust.hinta / kpl")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.costPrice,
                            expression: "costPrice"
                          }
                        ],
                        attrs: { type: "text", name: "product_costprice" },
                        domProps: { value: _vm.costPrice },
                        on: {
                          keypress: function($event) {
                            return _vm.forceFloat()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.costPrice = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "grid-col bp1-col-one-third" }, [
                      _c(
                        "label",
                        {
                          staticClass: "label label--small",
                          attrs: { for: "product_price" }
                        },
                        [_vm._v("Hinta / kpl")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.price,
                            expression: "price"
                          }
                        ],
                        attrs: { type: "text", name: "product_price" },
                        domProps: { value: _vm.price },
                        on: {
                          keypress: function($event) {
                            return _vm.forceFloat()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.price = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.product.variations.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "product-settings product-settings--modal product-settings--variations",
                          class: {
                            "product-settings--open": _vm.showVariations
                          }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "product-settings__toggle product-settings__toggle--small product-settings__toggle--variations",
                              class: {
                                "product-settings__toggle--active product-settings__toggle--variations-active":
                                  _vm.showVariations
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.toggleVariations($event)
                                }
                              }
                            },
                            [_vm._v("\n              Variaatiot\n            ")]
                          ),
                          _vm._v(" "),
                          _vm.showVariations
                            ? _c(
                                "div",
                                { staticClass: "product-settings__content" },
                                [
                                  _c("ProductVariations", {
                                    ref: "productVariations",
                                    attrs: {
                                      attributes:
                                        _vm.product.variation_attributes,
                                      variations: _vm.product.variations,
                                      "original-selections":
                                        _vm.product.variation,
                                      "hide-prices": false
                                    },
                                    on: { change: _vm.variationsChanged }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "cart-modal__profits" }, [
                    _c("div", { staticClass: "cart-modal__profit" }, [
                      _c("span", { staticClass: "label label--small" }, [
                        _vm._v("Kate-%")
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatPercent")(_vm.profitPercentage)
                          ) + " %"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cart-modal__profit" }, [
                      _c("span", { staticClass: "label label--small" }, [
                        _vm._v("Kate €")
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        [
                          _c("price", {
                            attrs: { price: _vm.profitAmount, cart: true }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cart-modal__price-container" }, [
                    _c("div", { staticClass: "cart-modal__price" }, [
                      _c(
                        "div",
                        { staticClass: "cart-modal__price-amount-container" },
                        [
                          _c("div", { staticClass: "label label--small" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$modeoL10n.sum) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "price-amount" },
                            [
                              _c("price", {
                                attrs: { price: _vm.totalPrice, cart: true }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "cart-modal__price-details" },
                        [
                          _c("span", { staticClass: "tax tax--big" }, [
                            _vm._v(_vm._s(_vm.$modeoL10n.vat) + " 0%")
                          ]),
                          _vm._v(" "),
                          _c("product-counter", {
                            attrs: { "default-count": _vm.product.quantity },
                            on: { change: _vm.quantityChanged }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cart-modal__actions" }, [
                  _c("div", { staticClass: "cart-modal__image-column" }, [
                    _c(
                      "button",
                      {
                        staticClass: "cart-modal__actions__delete",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.remove()
                          }
                        }
                      },
                      [_vm._v("\n              Poista tuote\n            ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "cart-modal__actions__buttons cart-modal__content-column"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "cart-modal__actions__button btn btn--secondary btn--secondary-med",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.cancel()
                            }
                          }
                        },
                        [_vm._v("\n              Peruuta\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "cart-modal__actions__button btn btn--med",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.confirm()
                            }
                          }
                        },
                        [_vm._v("\n              Tallenna\n            ")]
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.saving
                ? _c("div", { staticClass: "cart-modal__loading" }, [_vm._m(0)])
                : _vm._e(),
              _vm._v(" "),
              _vm.loadingImage
                ? _c("div", { staticClass: "cart-modal__loading" }, [_vm._m(1)])
                : _vm._e()
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cart-modal__loading__text" }, [
      _vm._v("\n          Tallennetaan"),
      _c("span", { staticClass: "blink", attrs: { "aria-hidden": "true" } }, [
        _c("span", { staticClass: "dot" }, [_vm._v(".")]),
        _c("span", { staticClass: "dot" }, [_vm._v(".")]),
        _c("span", { staticClass: "dot" }, [_vm._v(".")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "cart-modal__loading__text cart-modal__loading__text--image"
      },
      [
        _vm._v("\n          Tallennetaan kuvaa"),
        _c("span", { staticClass: "blink", attrs: { "aria-hidden": "true" } }, [
          _c("span", { staticClass: "dot" }, [_vm._v(".")]),
          _c("span", { staticClass: "dot" }, [_vm._v(".")]),
          _c("span", { staticClass: "dot" }, [_vm._v(".")])
        ])
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e6e19f72", { render: render, staticRenderFns: staticRenderFns })
  }
}